<template>
  <div v-html="content" style="padding: 5%">
{{content}}
  </div>
</template>

<script>
  import tool from '../assets/js/tool'
  export default {
    name: '',
    data() {
      return {
          content:''
      }
    },
    methods:{
      getTerms(){
        let data={
          id:this.$route.query.id
        };
        tool.postData('About/index2/id',data,(res)=>{
          this.content=res.data.data.content
        })
      }
    },
    mounted(){
      this.getTerms()
    },
    components: {}
  }
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/pages/term.vue